module.exports = __webpack_public_path__ + "static/media/teamIcon.f305555b.svg";